<li role="option" [tabindex]="0" [attr.aria-selected]="selected">
  <a
    #dropdownOption
    class="item"
    (click)="selectViaInteraction($event)"
    (keydown)="handleKeydown($event)"
    tabindex="-1"
    [ngClass]="{ noToggle: isDisabled }"
    data-test-id="dropdown-item-link"
  >
    <div class="checkmark-container">
      <span
        [hidden]="!selected"
        class="checkmark"
        data-test-id="dropdown-item-checkmark"
      ></span>
    </div>
    <span><ng-content></ng-content></span>
  </a>
</li>
